import React from 'react';
import PropTypes from 'prop-types';
import {Badge, Button} from 'antd';
import {useSelector} from 'react-redux';
import {AlertIcon} from '@web/assets/icons';
import Icon from './Icon';

IconBadge.propTypes = {
  collectionId: PropTypes.string.isRequired,
  offset: PropTypes.array,
  children: PropTypes.node,
  dot: PropTypes.bool,
};

function IconBadge({collectionId, children, ...props}) {
  const count = useSelector((state) => {
    return state.Collections[collectionId]?.hasNew?.count;
  });

  const syncError = useSelector((state) => {
    return state.Collections[collectionId]?.syncError;
  });

  return !syncError ?
    <Badge
      count={count ?? 0}
      overflowCount={99}
      showZero={false}
      // status="warning"
      // color={"cyan"}
      // offset={[10, -10]}
      // dot
      {...props}
    >
      <span>{children}</span>
    </Badge> :
    <label className="icon-btn">{children} <Icon name="TbExclamationCircleFilled" size={16} className="orange-icon" /></label>
}

export default IconBadge;
